import loggerGenerator from '@travel/logger';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { apiPath } from 'constants/api';

import type { ApiClient } from '@travel/api-client';
import type { MediaGalleryFetchAppendRequestParams, MediaGalleryResponse } from './types';
import type { ApiError, ApiErrorCodeType } from 'store/apiTypes';
import { noticeError } from '@travel/tracker';

const logger = loggerGenerator();

export const fetchMediaGallery = createAsyncThunk<
  MediaGalleryResponse,
  MediaGalleryFetchAppendRequestParams,
  { extra: { apiClient: ApiClient }; rejectValue: ApiError<ApiErrorCodeType> }
>('mediaGallery/fetchMediaReviews', async (params, { extra: { apiClient }, rejectWithValue }) => {
  try {
    const data = await apiClient.get(apiPath.mediaGallery.pathname(params.providerId), {
      values: { offset: params.offset, limit: params.limit },
    });

    return data;
  } catch (error) {
    logger.error('Fetch Media Reviews Failed', error);
    noticeError('Fetch Media Reviews Failed', error);

    return rejectWithValue(error);
  }
});

export const fetchAndAppendToMediaGallery = createAsyncThunk<
  MediaGalleryResponse,
  MediaGalleryFetchAppendRequestParams,
  { extra: { apiClient: ApiClient } }
>(
  'mediaGallery/fetchAndAppendMediaReviews',
  async (params, { extra: { apiClient }, rejectWithValue }) => {
    try {
      const data = await apiClient.get(apiPath.mediaGallery.pathname(params.providerId), {
        values: { offset: params.offset, limit: params.limit },
      });

      return data;
    } catch (error) {
      noticeError('Fetch and Append Media Reviews Failed', error);

      return rejectWithValue(error);
    }
  },
);
